/**
 * SAYM hero slider for phones.
 *
 * On small screens the hero's two media normally stack, which makes the section
 * twice as tall and pushes everything else down. Here they share one frame and
 * cross-fade instead. Desktop is untouched: the slider only runs below the
 * breakpoint, and everything is handed back to Horizon's own layout above it.
 *
 * Visitors who prefer reduced motion get the first medium, held still.
 */

const BREAKPOINT = '(max-width: 768px)';

/** @param {HTMLElement} grid */
function setup(grid) {
  const slides = /** @type {HTMLElement[]} */ ([...grid.querySelectorAll('.hero__media-wrapper')]);
  if (slides.length < 2) return;

  // 0 turns the slider off from the theme editor
  const seconds = Number(grid.dataset.saymHeroSlider);
  if (!Number.isFinite(seconds) || seconds <= 0) return;
  const viewport = window.matchMedia(BREAKPOINT);
  const stillness = window.matchMedia('(prefers-reduced-motion: reduce)');
  let index = 0;
  let timer = null;

  const show = (/** @type {number} */ next) => {
    slides.forEach((slide, i) => {
      slide.toggleAttribute('data-saym-slide-active', i === next);
      // Only the visible medium should be announced; the others are decorative duplicates.
      slide.setAttribute('aria-hidden', String(i !== next));
    });
  };

  const stop = () => {
    if (timer) clearInterval(timer);
    timer = null;
  };

  const start = () => {
    stop();
    index = 0;
    show(index);
    if (stillness.matches) return;
    timer = setInterval(() => {
      index = (index + 1) % slides.length;
      show(index);
    }, seconds * 1000);
  };

  const apply = () => {
    if (viewport.matches) {
      grid.setAttribute('data-saym-slider-on', '');
      start();
    } else {
      stop();
      grid.removeAttribute('data-saym-slider-on');
      slides.forEach((slide) => {
        slide.removeAttribute('data-saym-slide-active');
        slide.removeAttribute('aria-hidden');
      });
    }
  };

  viewport.addEventListener('change', apply);
  stillness.addEventListener('change', apply);

  // A background tab still fires intervals; pausing keeps the first medium in
  // place instead of jumping several slides when the visitor returns.
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stop();
    else if (viewport.matches) start();
  });

  apply();
}

document.querySelectorAll('[data-saym-hero-slider]').forEach((grid) => {
  if (grid instanceof HTMLElement) setup(grid);
});
